import { env } from '@/config/env';

export const isLocalDev = import.meta.env.DEV;
export const isDev = isLocalDev || env.FIREBASE_PROJECT_ID === 'bey-dev';
export const isStaging = env.FIREBASE_PROJECT_ID === 'bey-staging';
export const isProduction = !isLocalDev && !isDev && !isStaging;
